import { useMemo } from 'react';

import { lookupListAsRecordObject } from '@utils/graph-utils';

import { useGetMotorLovs } from '../proposal.slice';
import { MotorLovs } from '../types';

export function useMotorLovs(isMotor: boolean) {
  const { data } = useGetMotorLovs({ skip: !isMotor });

  return useMemo(() => {
    const plateCodes = lookupListAsRecordObject(data?.core?.getPlateCodeList);
    const usageTypes = lookupListAsRecordObject(data?.core?.getUsageTypeList);
    const engineTypes = lookupListAsRecordObject(data?.core?.getEngineTypeList);
    const brands = lookupListAsRecordObject(data?.core?.getMakeList);
    const colors = lookupListAsRecordObject(data?.core?.getColorList);
    const models = lookupListAsRecordObject(data?.core?.getModelList);

    const lovs: MotorLovs = {
      plateCodes: plateCodes,
      usageTypes: usageTypes,
      engineTypes: engineTypes,
      brands: brands,
      colors: colors,
      models: models
    };

    return lovs;
  }, [data]);
}
